export function initIntercom(config, license, user) {
  window.Intercom = null;
  window.loadIntercom(config.id, config.api);
  // shutdown so any cookies left from a previous user are cleared
  window.Intercom("shutdown");
  window.Intercom("boot", {
    custom_launcher_selector: ".messenger-item",
    email: user.email,
    name: user.name,
    user_id: user.id,
    user_hash: user.hash,
    role: intercomRoles[user.role] ?? user.role,
    language_override: user.preferredLanguage,
    avatar: {
      type: "avatar",
      image_url: user.imageUrl || "",
    },
    company: {
      company_id: user.company,
      name: user.company,
      plan: license.plan,
    },
  });
}

const intercomRoles = {
  observer: "Observer",
  user: "Member",
  admin: "Admin",
  planning_interval_admin: "PI Admin",
};
